import React from "react";
import * as S from "./styles";

interface SelectProps {
  id: string;
  name: string;
  placeholder?: any;
  label?: string;
  required: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  children?: React.ReactNode;
  defaultValue?: string;
  containerClassName?: string;
  error?: string;
  selected?: string;
  onBlur?: any;
  value?: string;
  disabled?: boolean;
}

function Select({
  id,
  name,
  placeholder,
  label,
  required,
  onChange,
  children,
  defaultValue,
  containerClassName = "",
  error,
  selected,
  value,
  onBlur,
  disabled = false,
}: SelectProps) {
  return (
    <S.SelectContainer className={containerClassName}>
      <label htmlFor={id}>{label}</label>

      <S.Select
        id={id}
        name={name}
        required={required}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        value={value}
      >
        {children}
      </S.Select>
      {error && <small>Nenhuma opção selecionada</small>}
    </S.SelectContainer>
  );
}

export default Select;
